<dialogtitle title="{{title}}" titleTheme="blue"></dialogtitle>

<mat-dialog-content class="{{ default ? 'container-center' : 'container-left' }}">
  <div class="nr-form-group apply-padding-top" fxLayout="column">
    <div *ngIf="isImage">
      <span class="image"><img [src]="isImagePath" alt="" /></span>
    </div>
    <div fxLayout="row" *ngIf="isImageData" class="imageContent" fxLayoutAlign="center center"> 
      <div fxLayout="column"><span class="image"><img [src]="isImagePath" alt="" /></span></div>
      <div fxLayout="column">
        <div class="imageContent" [innerHTML]="contentImageMessage | bold"></div>
    </div>
    </div>
    <div class="content" [innerHTML]="contentMessage | bold"></div>
  </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="btnShow">
  <div class="common-button-group" fxLayoutAlign="center center" fxLayoutGap="10px">
    <button *ngIf="btnCancelText !== null" type="button" class="common-button nr-button-white"id="cancelFocus" (click)="onCancel()">
      {{btnCancelText}}
    </button>
    <button *ngIf="btnConfirmText !== null" type="button" class="common-button nr-button-active" (click)="onConfirm()">
      {{btnConfirmText}}
    </button>
  </div>
</mat-dialog-actions>